export default "__VITE_ASSET__DXpvw19p__"